export const ROOT = "/";
export const COLLEGE = "/kampus";
export const MAJOR = "/major";
export const CAREER = "/karir";
export const SCHOLARSHIP = "/beasiswa";
export const FAVORITE = "/favorit";
export const PROFILE = "/profil";
export const CREATE_ACCOUNT = "/buat-akun";
export const FORGOT_PASSWORD = "/lupa-password";
export const COLLEGE_DETAIL = "/detail-kampus";
export const MAJOR_DETAIL = "/detail-jurusan";
export const CAREER_DETAIL = "/detail-karir";
export const SCHOLARSHIP_DETAIL = "/detail-beasiswa";

export const DASHBOARD = "/dashboard";
export const TNC = "/tnc";
export const PRIVACY_POLICY = "/privacy-policy";
